const t = "_wrapper_19ht5_1", e = "_list_19ht5_6", _ = "_item_19ht5_15", r = "_number_19ht5_32", o = "_eyebrow_19ht5_35", s = "_label_19ht5_36", b = "_wordWithoutNumbers_19ht5_48", l = {
  wrapper: t,
  list: e,
  item: _,
  number: r,
  eyebrow: o,
  label: s,
  wordWithoutNumbers: b
};
export {
  l as default,
  o as eyebrow,
  _ as item,
  s as label,
  e as list,
  r as number,
  b as wordWithoutNumbers,
  t as wrapper
};
